import Table, { TableHeader, TableBody, TableRow, TableItem } from "./Table";
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Item = TableItem;
export default Table;